
import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import * as Http from '../http'
import * as Business from '../utils/business';
import { ErrorCode } from '../const';
import moment from 'moment';

export default class UpdateNameAndReportDateModalModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            component: props.component,
            isShowUpdateNameAndReportDateModal: false,
            reportDateOld: props.reportDate,
            reportNameOld: props.reportName,
            reportDate: props.reportDate,
            reportName: props.reportName,
            calcType: props.calcType,
            forceClose: false
        }
    }

    componentDidMount() {
        console.log(this.state);
        console.log('Re mount');
    }

    onSave = () => {
        let { component, reportDateOld, reportNameOld, reportDate, reportName } = this.state;
        if (reportNameOld.startsWith(`${this.state.component}_`)) reportNameOld = reportNameOld.slice(`${this.state.component}_`.length);
        reportDateOld = moment(reportDateOld, 'DD/MM/YYYY').format('YYYY-MM-DD');
        if (reportName.startsWith(`${this.state.component}_`)) reportName = reportName.slice(`${this.state.component}_`.length);
        reportDate = moment(reportDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
        const data = {
            component,
            report_date_old: reportDateOld,
            report_name_old: reportNameOld,
            report_date: reportDate,
            report_name: reportName,
        }
        Http.updateNameAndReportDate(data)
            .then(res => {
                if (res && res.Success) {
                    this.setState({
                        reportDateOld: Business.convertToDate(reportDate),
                        reportNameOld: reportName,
                        reportDate: Business.convertToDate(reportDate),
                        reportName: reportName,
                    }, () => {
                        this.props.onCloseUpdateNameAndReportDateModalAndGetNewData(this.state.reportDate, this.state.reportName);
                    })
                } else {
                    switch (res.ErrorCode) {
                        case ErrorCode.PermissionDenie:
                            Business.showAlert({ title: 'Error', content: 'You are not permission' })
                            break;
                        case ErrorCode.Empty:
                            Business.showAlert({ title: 'Error', content: 'File is empty' })
                            break;
                        case ErrorCode.Exist:
                            Business.showAlert({ title: 'Error', content: 'Name already exists in the system' })
                            break;
                        case ErrorCode.DataInvalid:
                            Business.showAlert({ title: 'Error', content: res.Data || 'System Error' })
                            break;
                        case ErrorCode.UnknowError:
                            Business.showAlert({ title: 'Error', content: res.Data || 'System Error' })
                            break;
                        default:
                            Business.showAlert({ title: 'Error', content: res.Data || 'Update failed' })
                            break;
                    }
                }
            })
    }
 
    render() {
        const displayReportDate = `${this.state.reportDateOld || ''}`;
        let displayReportName = this.state.reportNameOld;
        if (displayReportName.startsWith(`${this.state.component}_`)) {
            displayReportName = displayReportName.slice(`${this.state.component}_`.length);
        }
        return (
            <Modal show={this.props.isShowUpdateNameAndReportDateModal} onHide={this.props.onCloseUpdateNameAndReportDateModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{`${displayReportDate} # ${displayReportName}`}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="content table-responsive table-full-width">
                        <form>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div className="form-group" style={{ width: '70%' }}>
                                <label htmlFor="exampleInputEmail1">Report Name</label>
                                <input type="text" className="form-control" id="reportname" onChange={event => {
                                    this.setState({ reportName: event.target.value })
                                }} />
                                </div>
                                <div className="form-group" style={{ width: '28%' }}>
                                <label htmlFor="exampleInputEmail12">Report Date</label>
                                <input type="date" className="form-control" id="reportDate"
                                    min="2010-01-01"
                                    max={moment(new Date(), 'YYYY-MM-DD').format('YYYY-MM-DD')}
                                    placeholder='MM/DD/YYYY' value={this.state.reportDate} onChange={event => { this.setState({ reportDate: event.target.value }) }}
                                />
                                </div>
                            </div>
                            <button type="button" className="btn btn-primary"
                                style={{
                                    backgroundColor: '#FFE600',
                                    borderColor: '#7F7E82',
                                    borderRadius: '5px',
                                    fontWeight: 600,
                                    marginLeft: "auto",
                                    float: 'left'
                                }}
                                onClick={() => {this.onSave()}}>Save
                            </button>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/UpdateNameAndReportDate.js